// Tracks.tsx
import React, { useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import communityFront from '../../assets/Tracks/communityTrackFront.png'; 
import communityBack from '../../assets/Tracks/communityTrackBack.png'; 
import intelFront from '../../assets/Tracks/intelTrackFront.png'; 
import intelBack from '../../assets/Tracks/intelTrackBack.png'; 
import tmobileFront from '../../assets/Tracks/tmobileTrackFront.png'; 
import tmobileBack from '../../assets/Tracks/tmobileTrackBack.png';
import wellnessFront from '../../assets/Tracks/wellnessTrackFront.png'; 
import wellnessBack from '../../assets/Tracks/wellnessTrackBack.png';
import awsFront from '../../assets/Tracks/awsTrackFront.png';
import awsBack from '../../assets/Tracks/awsTrackBack.png';

import { TracksText, TracksTitle, TrackImageContainer, Section, TracksImage } from './styles';

// Define the Card component within the same file
const Card: React.FC<{
  isFlipped: boolean;
  onClick: () => void;
  frontImage: string;
  backImage: string;
  altFront: string;
  altBack: string;
}> = ({ isFlipped, onClick, frontImage, backImage, altFront, altBack }) => (
  <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
    <div className="flip-card-front" onClick={onClick}>
      <TracksImage src={frontImage} alt={altFront} />
    </div>
    <div className="flip-card-back" onClick={onClick}>
      <TracksImage src={backImage} alt={altBack} />
    </div>
  </ReactCardFlip>
);

const Tracks: React.FC = () => {
  // Maintain flipped state for each card individually
  const [flippedCards, setFlippedCards] = useState<{ [key: string]: boolean }>({
    community: false,
    intel: false,
    tmobile: false,
    wellness: false,
    aws: false,
  });

  const handleFlip = (cardId: string) => {
    setFlippedCards(prevState => ({
      ...prevState,
      [cardId]: !prevState[cardId],
    }));
  };

  return (
    <Section id="tracks">
      <TracksTitle>Tracks</TracksTitle>
      <TracksText>
        We are excited to introduce our 2024 tracks! Click to read what adventures await you :]
      </TracksText>
      <TrackImageContainer>
        <Card
          isFlipped={flippedCards.community}
          onClick={() => handleFlip('community')}
          frontImage={communityFront}
          backImage={communityBack}
          altFront="Community Track"
          altBack="Community Track Back"
        />

        <Card
          isFlipped={flippedCards.wellness}
          onClick={() => handleFlip('wellness')}
          frontImage={wellnessFront}
          backImage={wellnessBack}
          altFront="Wellness Track"
          altBack="Wellness Track Back"
        />

        <Card
          isFlipped={flippedCards.tmobile}
          onClick={() => handleFlip('tmobile')}
          frontImage={tmobileFront}
          backImage={tmobileBack}
          altFront="T-Mobile Track"
          altBack="T-Mobile Track Back"
        />

        <Card
          isFlipped={flippedCards.intel}
          onClick={() => handleFlip('intel')}
          frontImage={intelFront}
          backImage={intelBack}
          altFront="Intel Track"
          altBack="Intel Track Back"
        />

        <Card
          isFlipped={flippedCards.aws}
          onClick={() => handleFlip('aws')}
          frontImage={awsFront}
          backImage={awsBack}
          altFront="AWS Track"
          altBack="AWS Track Back"
        />
      </TrackImageContainer>
    </Section>
  );
};

export default Tracks;
